import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../service/http.service';
import { LoginService } from '../security/login.service';
import { VivawalletPaymentNotification } from '../vivawallet-payment-notification';

@Component({
  selector: 'app-vivawallet-success',
  templateUrl: './vivawallet-success.component.html',
  styleUrls: ['./vivawallet-success.component.css']
})
export class VivawalletSuccessComponent implements OnInit {

  pleaseWait: string | null = null;

  constructor(
    private loginService: LoginService,
    private httpService: HttpService,
    private route: ActivatedRoute
  ) {
    this.loginService.activatedNavigationComponent = false;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      let notification = new VivawalletPaymentNotification(
        params["t"],
        params["s"],
        params["lang"],
        params["eventId"],
        params["eci"]
      );
      let language = params["lang"];
      this.pleaseWait = this.getWaitingMessage(language);
      this.httpService.postVivawalletPaymentNotification(notification).subscribe(res => {
        window.location.href = this.getRedirectUrl(language);
      }, error => {
        window.location.href = this.getRedirectUrl(language);
      });
    });
  }

  getWaitingMessage(lang: string){
    switch (lang) {
      case "fr-FR":
        return "Veuillez patienter...";
      case "nl-NL":
        return "Een ogenblik alstublieft...";
      default:
        return "Please wait...";
    }
  }

  getRedirectUrl(lang: string) {
    switch (lang) {
      case "fr-FR":
        return "https://languesvivantes.com/fr/merci";
      case "nl-NL":
        return "https://languesvivantes.com/nl/bedankt";
      default:
        return "https://languesvivantes.com/en/thank-you";
    }
  }

}
